// extracted by mini-css-extract-plugin
export default {"banner":"_2A74K1pp","iconWrap":"_30RCYt4R","message":"_1W3OTCh_","bold":"_1f-IoS4f","detail":"_3K7sAzAH","dismiss":"_1ip2tpB7"};